export default __webpack_public_path__ + "static/DEIPage-pattern-large-pink-252edacd88ced1e81f159d90d19bf945.png";